const ROOT_API = process.env.VUE_APP_ROOT_API;

const GET_JOURNAL_LPO = ROOT_API + 'get_journal_lpo.php';
const GET_LPO_POINTS = ROOT_API + 'get_site_data/get_site_points.php';
import store from '@/store';

import filter from './filter';

export default {
  namespaced: true,
  
  modules: {
    filter
  },

  state: {
    lpoList: [],
    selectedJournalLpo: null,

    currentPage: 1,
    perPage: 100,

    lpoListForGroup: [],
    currentPageForGroup: 1,
    perPageForGroup: 100,
  },
  mutations: {
    setLpoList(state, payload) {
      state['lpoList'] = payload;
    },
    setSelectedJournalLpo(state, payload) {
      state.selectedJournalLpo = payload;
    },
    setCurrentPage(state, payload) {
      state['currentPage'] = payload;
    },
    setLpoListForGroup(state, payload) {
      state['lpoListForGroup'] = payload;
    },
    setCurrentPageForGroup(state, payload) {
      state['currentPageForGroup'] = payload;
    }
  },
  getters: {
    totalRows(state, getters) {
      return +(state.lpoList.length ? state.lpoList[0].row_count : 0);
    },
    totalPages(state, getters) {
      return +Math.ceil(getters.totalRows / state.perPage);
    },

    totalRowsForGroup(state, getters) {
      return +(state.lpoListForGroup.length ? state.lpoListForGroup[0].row_count : 0);
    },
    totalPagesForGroup(state, getters) {
      return +Math.ceil(getters.totalRowsForGroup / state.perPageForGroup);
    }
  },
  actions: {
    getJournalLpo(context, payload) {
      const { state, rootState, getters, commit } = context;
      // const filter = payload;

      const filter = getters['filterStr'];

      const form = new FormData();
      form.append('current_page', state.currentPage);
      form.append('per_page', state.perPage);
      form.append('filter', filter);
      form.append('user_id', store.state.auth.userId);

      return fetch(GET_JOURNAL_LPO, {
        credentials: 'include',
        method: 'post',
        body: form
      })
      .then(res => res.json())
      .then(res => {
        commit('setLpoList', res);
      })
      .catch(err => console.log(err));
    },

    changePage(context, payload) {
      const { commit, dispatch } = context;

      commit('setCurrentPage', payload);
      return dispatch('getJournalLpo');
    },

    selectJournalLpo(context, payload) {
      const { state, commit, dispatch } = context;
      commit('setSelectedJournalLpo', payload);
    },

    getLpoListForGroup(context, filter) {
      const { state, rootState, commit } = context;

      // console.log('filter: ', filter);
      // return;
      const form = new FormData();
      form.append('current_page', state.currentPageForGroup);
      form.append('per_page', state.perPageForGroup);
      form.append('filter', filter);
      
      form.append('user_id', store.state.auth.userId);

      return fetch(GET_JOURNAL_LPO, {
        credentials: 'include',
        method: 'post',
        body: form
      })
      .then(res => res.json())
      .then(res => {
        commit('setLpoListForGroup', res);
      })
      .catch(err => console.log(err));
    },

    changePageForGroup(context, payload) {
      const { commit, dispatch } = context;

      commit('setCurrentPageForGroup', payload);
      return dispatch('getLpoListForGroup');
    },

  } 
};